import { CountryService } from './country.service';
import { ST_Roles } from './store-role.service';
import { StoreRolesService } from 'src/app/core/services/store-role.service';
import { CodiceAziendaZucchetti, CustSuppData, MandatiMago } from './../../model/customer';
import { LoginService } from 'src/app/core/services/login.service';
import { SettingsService } from './../../core/services/settings.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Customer, CustomerType } from 'src/app/model/customer';
import { environment } from 'src/environments/environment';
import { AdministrativeInfo, AdministrativeInfoContainer } from 'src/app/model/AdministrativeInfo';
import { UrlMaker } from 'src/app/commons/url-maker';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { MagoWebService } from './mago-web.service';
import { OperationResult } from '@tb/auth';
import { ProductCode } from 'src/app/model/industry';
import { ProductService } from './product.service';
import { StoreRole } from 'src/app/model/store-role';
import { MiniStorageService } from './mini-storage.service';
import { VerticalSolutionsService } from './verticalsolutions.service';
@Injectable({ providedIn: 'root' })
export class CustomerService {
    customer: Customer = new Customer();
    billingTo: CustSuppData = new CustSuppData();
    companyInfo: AdministrativeInfo = null;
    newPurchase: boolean = false;
    userAccountName: string;
    partnerCode: string;
    SDICode: string;
    codiceTitolare: string;
    public canSeeOnPremiseSection = false;
    public canSeeNFSSection = false;
    public canSeeVerticalSolution = false;
    public customer$ = new BehaviorSubject<Customer>(this.customer);
    public billingTo$ = new BehaviorSubject<CustSuppData>(this.billingTo);
    public companyInfo$ = new BehaviorSubject<AdministrativeInfo>(this.companyInfo);
    authorizationStored;
    public authorizationProperties: AuthorizationProperties;
    public magoCompanies: AdministrativeInfo[] = [];
    public ListOfMandati = new Map<string, string>();

    constructor(
        private http: HttpClient,
        private loginService: LoginService,
        public storeRoleService: StoreRolesService,
        private countryService: CountryService,
        private magoWebService: MagoWebService,
        private productService: ProductService,
        private miniStorage: MiniStorageService,
        private verticalSolutionService: VerticalSolutionsService
    ) {
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
    }

    ngOnInit() {
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
    }

    public async getCustomerInfo(email: string, provider = '', codiceazienda = ''): Promise<OperationResult> {
        const authInfo = this.loginService.getAuthInfoProperties();
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const jobj = {
            email: email,
            codiceazienda: codiceazienda,
            accountName: authInfo.accountName,
            authToken: environment.auth.authToken,
        };

        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.storeApiUrl)
            .appendSegment('customer')
            .appendSegment('info')
            .appendParameter('provider', provider)

            .toString();

        return this.http
            .post<OperationResult>(url.toString(), JSON.stringify(jobj), {
                headers: headers,
            })
            .toPromise();
    }
    public setMagoCloudCompanies(magocloudCompanies: AdministrativeInfo[]) {
        this.magoCompanies = magocloudCompanies;
    }
    public async getCustomerMasterData(
        email: string,
        accountName: string,
        provider: string,
        isZucchettiCompany: boolean,
        codiceazienda: string
    ): Promise<OperationResult> {
        //todo DA TOGLIERE
        await this.magoWebService.getDefaultSettingsFromDB();
        await this.setCodiceTitolare(codiceazienda);
        //chiamo il microservizio che mi restituisce eventuali informazioni sull'indirizzo email che si è
        //autenticato
        if (!isZucchettiCompany) {
            let response: OperationResult = await this.getCustomerInfo(email, provider, codiceazienda);
            if (!response.Result) return;

            this.magoCompanies = response.Content as AdministrativeInfo[];
        }
        let hasMCContract = AdministrativeInfoContainer.isResellerAndHasMagoCloudContract(this.magoCompanies);
        let hasMwContract = AdministrativeInfoContainer.isResellerAndHasMagoWebContract(this.magoCompanies);
        let hasMago4Contract = AdministrativeInfoContainer.isResellerAndHasMago4Contract(this.magoCompanies);
        //03/12/2021 se e' un rivenditore e ha il mandato di rivendita mago cloud i dati di fatturazione coincidono con
        //i dati del rivenditore
        let magocloudCompany: AdministrativeInfo = null;
        let magoWebCompany: AdministrativeInfo = null;
        let mago4Company: AdministrativeInfo = null;

        if (hasMago4Contract) {

            mago4Company = this.magoCompanies.find((x) => x.CompanyType == CustomerType.Rivenditore && x.ProductCode == ProductCode.MAGO4);
            if (!mago4Company) return;
            this.companyInfo = mago4Company;
            this.countryService.resellerCountry = this.companyInfo.Country;
            this.storeRoleService.isMago4_Partner = mago4Company.Mandato.length > 0;
            if (this.storeRoleService.isMago4_Partner) {
                this.storeRoleService.setST_Roles(accountName, ST_Roles[ST_Roles.ST_PARTNER_MAGO4].toString());
                this.ListOfMandati.set(mago4Company.ProductCode, mago4Company.Mandato);
                this.canSeeVerticalSolution =
                AdministrativeInfoContainer.isPlatinumPartner(this.ListOfMandati, ProductCode.MAGO4) ||
                AdministrativeInfoContainer.isGoldPartner(this.ListOfMandati, ProductCode.MAGO4);
            }
            //this.companyInfo$.next(this.companyInfo);
        }

        if (hasMCContract && hasMwContract) {
            //03/12/2021 mail con ok di Germano post riunione
            //visto che e' un rivenditore con mandato magocloud
            //metto le sue anagrafiche di fatturazione
            //chiedo al PAI i dati di fatturazione
            magocloudCompany = this.magoCompanies.find(
                (x) => x.CompanyType == CustomerType.Rivenditore && x.ProductCode == ProductCode.MAGOCLD
            );
            if (!magocloudCompany) return;
            this.companyInfo = magocloudCompany;
            this.productService.setResellerCode(this.companyInfo.CompanyCode);
            if (this.codiceTitolare) this.magoWebService.getInstancesList(this.codiceTitolare);
            this.countryService.resellerCountry = this.companyInfo.Country;
            this.storeRoleService.isMagoCloud_Partner = magocloudCompany.Mandato.length > 0;
            if (this.storeRoleService.isMagoCloud_Partner) {
                this.storeRoleService.setST_Roles(accountName, ST_Roles[ST_Roles.ST_PARTNER_MAGOCLOUD].toString());
                this.ListOfMandati.set(magocloudCompany.ProductCode, magocloudCompany.Mandato);
            }
            //this.companyInfo$.next(this.companyInfo);

            if (this.magoWebService.showMagoWebSection) {
                magoWebCompany = this.magoCompanies.find(
                    (x) => x.CompanyType == CustomerType.Rivenditore && x.ProductCode == ProductCode.MAGOWEB
                );
                if (!magoWebCompany) return;
                this.magoWebService.currCompanyCode = magoWebCompany.CompanyCode;
                this.magoWebService.isZucchettiDiretta = this.magoWebService.currCompanyCode == CodiceAziendaZucchetti;
                this.storeRoleService.isMagoWeb_Partner = magoWebCompany.Mandato.length > 0;
                if (this.storeRoleService.isMagoWeb_Partner) {
                    this.storeRoleService.setST_Roles(accountName, ST_Roles[ST_Roles.ST_PARTNER_MAGOWEB].toString());
                    this.ListOfMandati.set(magoWebCompany.ProductCode, magoWebCompany.Mandato);
                }
                // ha un contratto magoweb ed è un Betatester
                let betatester: boolean = magoWebCompany.IsBetatester;
                if (betatester) {
                    //se è microarea vaod a vedere sul db se c'è una riga con il ruolo ST_BETATESTER
                    if (this.magoWebService.currCompanyCode == CodiceAziendaZucchetti) {
                        let opResult: OperationResult = await this.storeRoleService.getAllST_Roles(accountName);
                        if (!opResult.Result) {
                            this.storeRoleService.isBetaTester = false;
                        } else {
                            let st_Roles: Array<StoreRole> = opResult.Content as Array<StoreRole>;
                            let index = st_Roles.findIndex(
                                (x) => x.RoleName === ST_Roles[ST_Roles.ST_BETATESTER].toString() && x.Disabled == 0
                            );
                            this.storeRoleService.isBetaTester = index > -1;
                            if (index == -1)
                                this.storeRoleService.removeRoleFromSession(ST_Roles[ST_Roles.ST_BETATESTER].toString(), accountName);
                        }
                    } else {
                        if (environment.production == false) {
                            this.storeRoleService.setST_Roles(accountName, ST_Roles[ST_Roles.ST_BETATESTER].toString());
                            this.storeRoleService.isBetaTester = true;
                        }
                    }
                }
            }
            //30/06/2023 con l'uscita di MagoWeb la onpremises si è deciso di oscurarla
            this.canSeeOnPremiseSection = false; //AdministrativeInfoContainer.CanSeeOnPremiseSection(this.companyInfo);
            this.canSeeNFSSection =
                AdministrativeInfoContainer.isPlatinumPartner(this.ListOfMandati, ProductCode.MAGOCLD) ||
                AdministrativeInfoContainer.isGoldPartner(this.ListOfMandati, ProductCode.MAGOCLD) ||
                AdministrativeInfoContainer.isPlatinumPartner(this.ListOfMandati, ProductCode.MAGOWEB) ||
                AdministrativeInfoContainer.isGoldPartner(this.ListOfMandati, ProductCode.MAGOWEB) ||
                AdministrativeInfoContainer.isSilverPartner(this.ListOfMandati, ProductCode.MAGOWEB);
        } else if (hasMwContract) {
            magoWebCompany = this.magoCompanies.find(
                (x) => x.CompanyType == CustomerType.Rivenditore && x.ProductCode == ProductCode.MAGOWEB
            );
            if (!magoWebCompany) return;
            this.companyInfo = magoWebCompany;

            this.productService.setResellerCode(this.companyInfo.CompanyCode);
            if (this.codiceTitolare) this.magoWebService.getInstancesList(this.codiceTitolare);
            this.countryService.resellerCountry = this.companyInfo.Country;
            if (this.magoWebService.showMagoWebSection) {
                this.magoWebService.currCompanyCode = magoWebCompany.CompanyCode;
                this.magoWebService.isZucchettiDiretta = this.magoWebService.currCompanyCode == CodiceAziendaZucchetti;
                this.storeRoleService.setST_Roles(accountName, ST_Roles[ST_Roles.ST_PARTNER_MAGOWEB].toString());
                this.storeRoleService.isMagoWeb_Partner = true;
            }
            // ha un contratto magoweb ed è un Betatester
            let betatester: boolean = magoWebCompany.IsBetatester;
            if (betatester && environment.production == false) {
                this.storeRoleService.setST_Roles(accountName, ST_Roles[ST_Roles.ST_BETATESTER].toString());
                this.storeRoleService.isBetaTester = true;
            }

            this.ListOfMandati.set(magoWebCompany.ProductCode, magoWebCompany.Mandato);
            //this.companyInfo$.next(this.companyInfo);
            this.canSeeOnPremiseSection = false; //AdministrativeInfoContainer.CanSeeOnPremiseSection(this.companyInfo);
            this.canSeeNFSSection =
                AdministrativeInfoContainer.isPlatinumPartner(this.ListOfMandati, ProductCode.MAGOCLD) ||
                AdministrativeInfoContainer.isGoldPartner(this.ListOfMandati, ProductCode.MAGOCLD) ||
                AdministrativeInfoContainer.isPlatinumPartner(this.ListOfMandati, ProductCode.MAGOWEB) ||
                AdministrativeInfoContainer.isGoldPartner(this.ListOfMandati, ProductCode.MAGOWEB) ||
                AdministrativeInfoContainer.isSilverPartner(this.ListOfMandati, ProductCode.MAGOWEB);
        } else if (hasMCContract) {
            magocloudCompany = this.magoCompanies.find(
                (x) => x.CompanyType == CustomerType.Rivenditore && x.ProductCode == ProductCode.MAGOCLD
            );
            if (!magocloudCompany) return;
            this.companyInfo = magocloudCompany;
            //this.companyInfo$.next(this.companyInfo);
            this.productService.setResellerCode(this.companyInfo.CompanyCode);
            if (this.codiceTitolare) this.magoWebService.getInstancesList(this.codiceTitolare);

            this.storeRoleService.isMagoCloud_Partner = magocloudCompany.Mandato.length > 0;
            if (this.storeRoleService.isMagoCloud_Partner) {
                this.storeRoleService.setST_Roles(accountName, ST_Roles[ST_Roles.ST_PARTNER_MAGOCLOUD].toString());
                this.ListOfMandati.set(magocloudCompany.ProductCode, magocloudCompany.Mandato);
            }

            this.countryService.resellerCountry = this.companyInfo.Country;
            this.ListOfMandati.set(this.companyInfo.ProductCode, this.companyInfo.Mandato);
            this.canSeeNFSSection =
                AdministrativeInfoContainer.isPlatinumPartner(this.ListOfMandati, ProductCode.MAGOCLD) ||
                AdministrativeInfoContainer.isGoldPartner(this.ListOfMandati, ProductCode.MAGOCLD) ||
                AdministrativeInfoContainer.isPlatinumPartner(this.ListOfMandati, ProductCode.MAGOWEB) ||
                AdministrativeInfoContainer.isGoldPartner(this.ListOfMandati, ProductCode.MAGOWEB) ||
                AdministrativeInfoContainer.isSilverPartner(this.ListOfMandati, ProductCode.MAGOWEB);
        } else {
            //e' un rivenditore senza contratto magocloud o magoweb
            if (AdministrativeInfoContainer.isReseller(this.magoCompanies)) {
                let companyInfo: AdministrativeInfo = null;
                companyInfo = this.magoCompanies.filter((x) => x.CompanyType == CustomerType.Rivenditore)[0];
                if (!companyInfo) return;
                this.companyInfo = companyInfo;
                //this.companyInfo$.next(this.companyInfo);
                this.productService.setResellerCode(this.companyInfo.CompanyCode);
                if (this.codiceTitolare) this.magoWebService.getInstancesList(this.codiceTitolare);
                this.countryService.resellerCountry = this.companyInfo.Country;

                // let custSuppData: OperationResult = await this.getCustSuppData(this.companyInfo.CustSupp);
                // this.customer = custSuppData.Content == null ? null : (custSuppData.Content as Customer);
                // this.customer$.next(this.customer);
            } else {
                let companyInfo: AdministrativeInfo = null;
                companyInfo = this.magoCompanies[0];
                if (!companyInfo) return;
                this.companyInfo = companyInfo;
                this.productService.setResellerCode(this.companyInfo.CompanyCode);
                if (this.codiceTitolare) this.magoWebService.getInstancesList(this.codiceTitolare);
                this.countryService.resellerCountry = this.companyInfo.Country;
                let mdResponse: OperationResult = await this.getMasterData(this.companyInfo);
                let savedMasterData: Customer = mdResponse.Content == null ? null : (mdResponse.Content as Customer);
                this.customer = savedMasterData;
                this.customer$.next(this.customer);
            }
        }
        this.verticalSolutionService.resellerCompanyName = this.companyInfo.CompanyName;
        //se il codice è 0110G081 setto come codiceazineda quello di Microarea 113527
        if (this.companyInfo.CompanyCode == '0110G081') {
            this.verticalSolutionService.currentCodiceAzienda = '113527';
        }
        this.companyInfo$.next(this.companyInfo);
        // let isAllowed = this.companyInfo ? await this.amazonDspService.WhoIsAuthorizedToSeeAmazonCard(this.companyInfo) : false;
        // if (this.companyInfo.CompanyType == CustomerType.Rivenditore && isAllowed) {
        //     this.storeRoleService.setST_Roles(accountName, ST_Roles[ST_Roles.ST_PARTNER_ADSP].toString());
        //     this.storeRoleService.isAmazonDSP_Partner = true;
        // }
        //30/06/2023 con l'uscita di MagoWeb la onpremises si è deciso di oscurarla
        this.canSeeOnPremiseSection = false; //AdministrativeInfoContainer.CanSeeOnPremiseSection(this.companyInfo);
        this.canSeeNFSSection =
            AdministrativeInfoContainer.isPlatinumPartner(this.ListOfMandati, ProductCode.MAGOCLD) ||
            AdministrativeInfoContainer.isGoldPartner(this.ListOfMandati, ProductCode.MAGOCLD) ||
            AdministrativeInfoContainer.isPlatinumPartner(this.ListOfMandati, ProductCode.MAGOWEB) ||
            AdministrativeInfoContainer.isGoldPartner(this.ListOfMandati, ProductCode.MAGOWEB) ||
            AdministrativeInfoContainer.isSilverPartner(this.ListOfMandati, ProductCode.MAGOWEB);
    }
    public async setCodiceTitolare(codiceazienda: string) {
        let codiceTitolare = parseInt(codiceazienda);
        if (codiceazienda && codiceazienda.length > 0) this.codiceTitolare = codiceTitolare.toString();
        else {
            this.miniStorage.get('codiceazienda').subscribe(
                (r) => {
                    if (r) {
                        this.codiceTitolare = codiceTitolare.toString();
                    }
                },
                (e) => {
                    console.log(`An error occurred while getting codiceazienda ${e}`);
                }
            );
        }
    }

    public async getMasterData(companyInfo: AdministrativeInfo): Promise<OperationResult> {
        const authInfo = this.loginService.getAuthInfoProperties();
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const jobj = {
            companyInfo: companyInfo,
            accountName: authInfo.accountName,
        };
        return this.http
            .post<OperationResult>(environment.settings.storeApiUrl + 'customer/get', JSON.stringify(jobj), {
                headers: headers,
            })
            .toPromise();
    }

    clear() {
        this.customer = new Customer();
        this.billingTo = new CustSuppData();
        this.companyInfo = null;
        this.customer$.next(this.customer);
        this.billingTo$.next(this.billingTo);
        this.companyInfo$.next(this.companyInfo);
    }

    public async saveCustomer(customer: Customer, isSubscriber: boolean): Promise<OperationResult> {
        const authInfo = this.loginService.getAuthInfoProperties();
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const jobj = {
            customer: customer,
            accountName: authInfo.accountName,
            isSubscriber: isSubscriber,
        };
        return this.http
            .post<OperationResult>(environment.settings.storeApiUrl + 'customer/new', JSON.stringify(jobj), {
                headers: headers,
            })
            .toPromise();
    }

    public setZuccchettiCompanyInfo(codiceazienda: string) {
        let magoCompanies: AdministrativeInfo[] = [];
        let companyMW: AdministrativeInfo = new AdministrativeInfo();
        companyMW.CompanyCode = codiceazienda;
        companyMW.CompanyName = 'Zucchetti Spa';
        companyMW.CompanyType = CustomerType.Rivenditore;
        companyMW.ProductCode = ProductCode.MAGOWEB;
        companyMW.Mandato = MandatiMago.PLATINUM;
        companyMW.Country = 'IT';
        magoCompanies.push(companyMW);

        let companyMC: AdministrativeInfo = new AdministrativeInfo();
        companyMC.CompanyCode = codiceazienda;
        companyMC.CompanyName = 'Zucchetti Spa';
        companyMC.CompanyType = CustomerType.Rivenditore;
        companyMC.ProductCode = ProductCode.MAGOCLD;
        companyMC.Mandato = MandatiMago.PLATINUM;
        companyMC.Country = 'IT';
        magoCompanies.push(companyMC);
        this.setMagoCloudCompanies(magoCompanies);
        this.countryService.setCountry('IT');

        let companyM4: AdministrativeInfo = new AdministrativeInfo();
        companyM4.CompanyCode = codiceazienda;
        companyM4.CompanyName = 'Zucchetti Spa';
        companyM4.CompanyType = CustomerType.Rivenditore;
        companyM4.ProductCode = ProductCode.MAGO4;
        companyM4.Mandato = MandatiMago.PLATINUM;
        companyM4.Country = 'IT';
        magoCompanies.push(companyM4);
        this.setMagoCloudCompanies(magoCompanies);
        this.countryService.setCountry('IT');

        return magoCompanies;
    }
}
